module.exports = __webpack_public_path__ + "assets/img/2.fc6ccc88.png";